import {resizeFile} from "@/helpers/h";
import {useState} from "react";
import {Button} from "./button";

export const InputFile = ({
  defaultValue,
  onChange,
  id = "evidence",
  noPreview,
  label,
  ...props
}) => {
  const [previewImage, setPreviewImage] = useState(
    defaultValue ? defaultValue : "https://placehold.co/150"
  );

  const [fileName, setFileName] = useState();

  const Comp = "input";

  return (
    <div className="flex flex-col md:flex-row items-start md:items-end gap-[16px] mb-[20px] mt-3">
      {previewImage && !noPreview && (
        <img
          src={previewImage}
          className="w-[100px] aspect-square object-cover rounded-[8px]"
        />
      )}
      <div className="flex flex-col items-start gap-[10px]">
        <span className="font-bold text-[16px]">{label || "Upload File"}</span>
        <Button
          variant="primary"
          as="label"
          htmlFor={id}
          className="max-w-[200px] overflow-hidden line-clamp-1 whitespace-nowrap"
          title={fileName}
        >
          {fileName && noPreview ? fileName : "click to upload"}
        </Button>
        <Comp
          {...props}
          type="file"
          className="hidden"
          id={id}
          onChange={async (e) => {
            onChange(e);
            const file = e.target.files[0];
            if (file.type.includes("image")) {
              const image = await resizeFile(file);
              const url = URL.createObjectURL(image);
              setPreviewImage(url);
            }
            setFileName(file.name);
          }}
        />
      </div>
    </div>
  );
};
